import { Button, Typography } from 'darrius';
import { type ComponentType } from 'react';
import { MdClose } from 'react-icons/md';
import Modal from 'react-modal';

import styles from './RecurrencyModal.module.scss';

interface IRecurrencyModalProps {
  showRecurrencyModal: boolean;
  setShowRecurrencyModal: any;
  setTurnOffAutoBuy: any;
  setKeepRecurrency: any;
}

const ModalSafeForReact18 = Modal as ComponentType<ReactModal['props']>;

export const RecurrencyModal = ({
  showRecurrencyModal,
  setShowRecurrencyModal,
  setKeepRecurrency,
  setTurnOffAutoBuy,
}: IRecurrencyModalProps) => {
  function handleCloseModal() {
    setShowRecurrencyModal(false);
  }

  return (
    <ModalSafeForReact18
      isOpen={showRecurrencyModal}
      onRequestClose={handleCloseModal}
      className={`recurrency-modal ${styles['recurrency-modal']} `}
      ariaHideApp={false}
      portalClassName={styles.ReactModal__Overlay}
      style={{
        overlay: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0000004d',
        },
      }}
    >
      <button
        className={`recurrency-modal__close-btn ${styles['recurrency-modal__close-btn']} `}
        onClick={handleCloseModal}
      >
        <MdClose size={24} />
      </button>
      <div
        className={`recurrency-modal__image ${styles['recurrency-modal__image']} `}
      >
        <img
          src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/check-credit-card.svg`}
          alt="Imagem de uma ilustração cartão de crédito para simulara uma recorrencia de compra"
        />
      </div>
      <div>
        <Typography.Subtitle size="l" className="center-sm">
          Quer mesmo desligar a recompra automática?
        </Typography.Subtitle>
        <Typography.Text className={`${styles.text} center-sm`}>
          Ela só é feita quando suas moedas estão para esgotar. Dessa forma,
          você nunca perde nenhum pedido por falta de moedas!
        </Typography.Text>
      </div>
      <Button.Root fullWidth size="small" onClick={setKeepRecurrency}>
        Manter recompra automática
      </Button.Root>
      <Button.Root
        variation="clear"
        fullWidth
        size="small"
        onClick={setTurnOffAutoBuy}
      >
        Desligar recompra automática
      </Button.Root>
    </ModalSafeForReact18>
  );
};
